interface CommentItem {
  avatar: string;
  name: string;
  time: string;
  show: string;
  rating: number;
  content: string;
}

const comments: CommentItem[] = [
  {
    avatar: "https://readdy.ai/api/search-image?query=A%20cute%20cat%20avatar%20in%20minimalist%20flat%20illustration%20style%2C%20warm%20orange%20and%20cream%20colors%2C%20simple%20circle%20composition%2C%20friendly%20expression&width=120&height=120&seq=avatar-01&orientation=squarish",
    name: '深夜追剧人',
    time: '2小时前',
    show: '星落长河',
    rating: 5,
    content: '追了两个月终于等到大结局！最后一集哭得我稀里哗啦的，制作真的太精良了，每一帧都能当壁纸。夜猫影院更新速度真的快，比隔壁平台早好几个小时，强推！',
  },
  {
    avatar: "https://readdy.ai/api/search-image?query=A%20cute%20owl%20avatar%20in%20minimalist%20flat%20illustration%20style%2C%20warm%20amber%20colors%2C%20simple%20circle%20composition%2C%20wise%20expression&width=120&height=120&seq=avatar-02&orientation=squarish",
    name: '剧荒终结者',
    time: '5小时前',
    show: '暗夜追踪',
    rating: 5,
    content: '原本只是睡前看一集打发时间，结果一口气刷到凌晨四点。剧情太紧凑了，每一个细节都是伏笔，现在满脑子都是凶手到底是谁。强烈建议夜猫子们白天看，不然真的停不下来。',
  },
  {
    avatar: "https://readdy.ai/api/search-image?query=A%20cute%20fox%20avatar%20in%20minimalist%20flat%20illustration%20style%2C%20warm%20orange%20and%20white%20colors%2C%20simple%20circle%20composition%2C%20playful%20expression&width=120&height=120&seq=avatar-03&orientation=squarish",
    name: '韩剧小达人',
    time: '8小时前',
    show: '月之恋人',
    rating: 4,
    content: '男主太帅了女主太美了，两个人的化学反应绝了！最喜欢第三集那个雨中重逢的场景，反复看了五遍。希望夜猫影院多上一些这种高甜韩剧，我的少女心需要投喂。',
  },
  {
    avatar: "https://readdy.ai/api/search-image?query=A%20cute%20raccoon%20avatar%20in%20minimalist%20flat%20illustration%20style%2C%20warm%20brown%20colors%2C%20simple%20circle%20composition%2C%20curious%20expression&width=120&height=120&seq=avatar-04&orientation=squarish",
    name: '科幻发烧友',
    time: '12小时前',
    show: '边缘世界',
    rating: 5,
    content: '《边缘世界》第三季质量不减反增，世界观构建太宏大了。每集看完都要去论坛看分析帖才能完全理解。感谢夜猫影院同步更新中字版，不然又要等好久。',
  },
  {
    avatar: "https://readdy.ai/api/search-image?query=A%20cute%20hamster%20avatar%20in%20minimalist%20flat%20illustration%20style%2C%20warm%20golden%20colors%2C%20simple%20circle%20composition%2C%20happy%20expression&width=120&height=120&seq=avatar-05&orientation=squarish",
    name: '深夜食堂',
    time: '1天前',
    show: '都市夜话',
    rating: 4,
    content: '作为一个在大城市打拼的年轻人，看《都市夜话》真的感触很深。每个角色都像身边的同事和朋友，那些职场困境和情感选择太真实了。期待第二季，据说8月就上线了！',
  },
];

export default function SectionComments() {
  return (
    <section id="comments" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          观众热评
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">来自真实追剧党的走心评价</p>
        <div className="space-y-4">
          {comments.map((item, idx) => (
            <div key={idx} className="bg-background-100 rounded-xl p-5 border border-background-200/70">
              <div className="flex items-start gap-4">
                <img
                  src={item.avatar}
                  alt={item.name}
                  className="w-11 h-11 rounded-full object-cover shrink-0"
                  width="120"
                  height="120"
                />
                <div className="flex-1 min-w-0">
                  <div className="flex flex-wrap items-center gap-2 mb-1">
                    <h3 className="font-heading text-sm text-foreground-900">{item.name}</h3>
                    <span className="text-[11px] text-foreground-400">{item.time}</span>
                    <span className="text-[10px] font-medium px-2 py-0.5 rounded bg-primary-100 text-primary-700 whitespace-nowrap">
                      在看《{item.show}》
                    </span>
                  </div>
                  <div className="flex items-center gap-0.5 mb-2">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i
                        key={i}
                        className={`text-xs ${i < item.rating ? 'ri-star-fill text-amber-400' : 'ri-star-line text-foreground-300'}`}
                      ></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.content}</p>
                  <div className="flex items-center gap-4 mt-3 text-xs text-foreground-400">
                    <span className="flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                      <i className="ri-thumb-up-line"></i> 有用
                    </span>
                    <span className="flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                      <i className="ri-chat-1-line"></i> 回复
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}